<template>
  <div class="home-user">
     <el-form
      :inline="true"
    >
      <el-form-item label="请选择">
         <el-date-picker
          v-model="value2"
          type="month"
           value-format="yyyy-MM"
          placeholder="选择年月">
        </el-date-picker>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="getDataList">查询</el-button>
        <!-- <el-button @click="cleaList()">重置</el-button> -->
        
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="getUpdataClick" class="float-right">下载表格</el-button>
      </el-form-item>
      
    </el-form>
    <div style="min-width:1000px; min-height:430px; overflow:scroll;">
      <table border="1" class="table" rules="all" id="table">
        <tr>
          <th style='width:210px;'>姓名</th>
          <th style='width:210px;' v-for='item in th' :key='item.skillId'>{{item.skillName}}({{item.energy}}/{{item.unit}})</th>
          <!-- <th style='width:210px;'>狗粮汇总</th> -->
        </tr>
        <tr v-for='(item,i) in td' :key='i'>
          <!-- <td>11</td> -->
          <td>{{td[i][i].realName}}</td>
          <!-- <td>{{(td[i][i].energy*td[i][i].number).toFixed(1)}}</td> -->
          <td v-for='(items,indexs) in td[i]' :key='indexs'>{{items.energy.toFixed(1)}}</td>
          <!-- <td>{{td[i][i].energy}}</td> -->
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { userskillstatisticst,download }  from './api'
import { getToken, removeToken } from '@/utils/auth'
export default {
  data() {
    return {
      dataForm:{},
      th:[],
      td:[],
      tdData:[],
      value2:null, //当前月
    }
  },
  mounted() {
     var date1 = new Date();
      var date2 = new Date(date1);
      var agoDay = `${date2.getFullYear()}-${date2.getMonth() + 1<10?`0${date2.getMonth() + 1}`:date2.getMonth() + 1}-01`;
    this.value2 = agoDay
    console.log(this.value2)
    // month =(month<10 ? "0"+month:month); 
    // var mydate = (year.toString()/+month.toString();
   this._dataList(this.value2)
  },
  methods:{
    // 点击下载
    getUpdataClick() {
      console.log(window.location.href)
      let url =window.location.href.split("#")[0];
      console.log(url.length)
      let u = url.slice(0,url.length-11)
      console.log(u)
      window.open(u+"/zxnl/sys/userskillstatistics/download?yearMonth="+this.value2+"&token="+getToken())
      // window.open(url+'zxnl/sys/userskillstatistics/download?yearMonth='+this.value2+'&token='+getToken())
      // download({yearMonth:this.value2}).then(res =>{
        
      // })
    },
    // 点击查询
    getDataList() {
      this._dataList(this.value2)
    },
    // 数据列表
    _dataList(time){
       userskillstatisticst({yearMonth:time}).then(res =>{
      if(res.code==0) {
        this.th = res.skills
        let data = res.statistics
        let arr = [];
        for(var i=0;i<data.length;i++) {
          // console.log(data[i])
          for(let key in data[i]){
            // console.log(data[i][key])
            
            // let obj={};
            for(var m=0;m<data[i][key].length;m++){
             
              data[i][key][m].numberAll+=(data[i][key][m].energy*data[i][key][m].number).toFixed(1)
              //  console.log(data[i][key][m].numberAll+=(data[i][key][m].energy*data[i][key][m].number).toFixed(1))
              // arr.push(obj)
            }
            arr.push(data[i][key])
          }
        }
        console.log(arr)
        this.td = arr
      }
    })
    },
  }
}
</script>
<style lang="less" scoped>
.table{
 width: 5000px;
  overflow-y: auto;
}
.float-right{
 margin-left: 30px;
}
th{
   border: 1px solid #bbb;
   padding: 10px;
   font-weight: bold;
}
td{
  line-height: 20px;
  padding: 10px;
  border: 1px solid #bbb;
}

</style>